import { startCase } from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnSessionService } from '@lib/auth/services';
import { SnFormFieldConfig } from '@lib/form';
import { t, TranslationService } from '@lib/translation';

@Component({
  templateUrl: './two-factor-auth-dialog.component.html',
  styleUrls: ['./two-factor-auth-dialog.component.scss'],
})
export class TwoFactorAuthDialogComponent implements OnInit, OnDestroy {
  public otpForm = new UntypedFormGroup({});
  public backupForm = new UntypedFormGroup({});
  public formModel: any = {};
  public isLoading: boolean = false;
  public backupField: SnFormFieldConfig[] = [
    {
      key: 'backupCode',
      type: 'input',
      name: 'uid',
      templateOptions: this._translationService.createTranslatedFieldOptions(
        'account.dialogs.mfa.signIn.backupCode',
        'account.dialogs.mfa.signIn.enterBackupCode',
        {
          appearance: 'outline',
          required: true,
          type: 'tel',
        }
      ),
    },
  ];
  public otpField: SnFormFieldConfig[] = [
    {
      key: 'otpCode',
      type: 'input',
      name: 'uid',
      templateOptions: this._translationService.createTranslatedFieldOptions(
        'account.dialogs.mfa.signIn.otpCode',
        'account.dialogs.mfa.signIn.enterOtpCode',
        {
          appearance: 'outline',
          required: true,
          type: 'tel',
        }
      ),
    },
  ];
  public isBackup: boolean = false;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly _sessionService: SnSessionService,
    private readonly _dialogRef: MatDialogRef<TwoFactorAuthDialogComponent>,
    private readonly _translationService: TranslationService,
  ) {}

  public ngOnInit(): void {}

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public toStartCase(text: string): string {
    return startCase(text);
  }

  public useBackupCodes(): void {
    this.isBackup = !this.isBackup;
  }

  public submitForm(): void {
    this.isLoading = true;
    if (this.isBackup) {
      this._sessionService
        .authBackupCode(this.data.token, this.formModel.backupCode)
        .pipe(takeUntil(this._destroy$))
        .subscribe({
          next: (response) => {
            this.isLoading = false;
            this._dialogRef.close(response);
          },
          error: (err) => {
            this.isLoading = false;
            this.backupForm.setErrors(err.error);
          },
        });
    } else {
      this._sessionService
        .authTwoFactor(this.data.token, this.formModel.otpCode)
        .pipe(takeUntil(this._destroy$))
        .subscribe({
          next: (response) => {
            this.isLoading = false;
            this._dialogRef.close(response);
          },
          error: (err) => {
            this.isLoading = false;
            this.otpForm.setErrors(err.error);
          },
        });
    }
  }
}
